<template>
	<div class="content">
		<div class="md-layout">
			<div class="md-layout-item md-medium-size-10 md-size-33"></div>
			<div class="md-layout-item md-medium-size-80 md-size-33 middle">
				<img src="@/assets/img/logo-login.png">
				<md-card class="card">
					<md-card-header data-background-color="orange">
						<h4 class="title">ចូលក្នុងប្រព័ន្ធ</h4>
						<p class="category">សូមបញ្ចូលឈ្មោះ និង ពាក្យសម្ងាត់</p>
					</md-card-header>

					<md-card-content>
						<form @submit.prevent="login()">
							<div class="md-layout">
								<div class="md-layout-item md-small-size-100 md-size-100">
									<md-field>
										<label>ឈ្មោះអ្នកប្រើប្រាស់</label>
										<md-input v-model="user.username" type="text"></md-input>
									</md-field>
								</div>
								<div class="md-layout-item md-small-size-100 md-size-100">
									<md-field>
										<label>ពាក្យសម្ងាត់</label>
										<md-input v-model="user.password" type="password"></md-input>
									</md-field>
								</div>
								<div class="md-layout-item md-size-100 text-right">
									<md-button class="md-raised md-primary" type="submit">ចូលក្នុងប្រព័ន្ធ</md-button>
								</div>
							</div>
						</form>
					</md-card-content>
				</md-card>
			</div>
			<div class="md-layout-item md-medium-size-25 md-size-33"></div>
		</div>
	</div>
</template>

<script>
	export default {
		created() {

			this.$cookie.delete('auth');
		},
		data() {
			return {
				isValid: false,
				user: {
					username: "",
					password: ""
				}
			}
		},
		methods: {
			login() {
				let username = this.user.username
				let password = this.user.password

				if (!this.checkValidation()) return false;

				this.user.password = "";

				this.$http.post(this.config.api + "/admin/login", { username, password }).then(res => {

					if (res.body.status == 'success') {
						this.$store.state.authentication.loggedIn = true;
						this.$store.state.authentication.authToken = res.body.data.token;
						this.$store.state.authentication.name = res.body.data.name;
						this.$cookie.set('auth', res.body.data.token, 3);
						this.$cookie.set('name', res.body.data.name, 3);
					}
				})
				// if (username == 'admin' && password == 'testingtesting') {
				// 	this.$store.state.authentication.loggedIn = true;
				// } else {
				// 	this.$notification.notify({
				// 		message: "Incorrect username or password",
				// 		icon: 'error',
				// 		type: 'danger'
				// 	})
				// }
			},
			checkValidation() {
				if (this.user.username.length > 2 && this.user.password.length > 2) {
					return true;
				} else {
					this.$notification.notify({
						message: "សូមបញ្ចូលព័ត៌មាន។",
						icon: 'error',
						type: 'danger'
					})
					return false;
				}
			}
		}
	}
</script>

<style scoped>
	.card {
		margin-top: 80px;
	}

	.middle {
		position: relative;
		margin-top: 12vh;
	}
</style>



// WEBPACK FOOTER //
// src/pages/Login.vue